import { render } from "./CatalogGallery.vue?vue&type=template&id=4c08a07a&scoped=true"
import script from "./CatalogGallery.vue?vue&type=script&lang=js"
export * from "./CatalogGallery.vue?vue&type=script&lang=js"

import "./CatalogGallery.vue?vue&type=style&index=0&id=4c08a07a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c08a07a"]])

export default __exports__